/* global Evergage */
import { getSite } from '../../../global/environments/site.js'
import {
  CLOSED_END_FUND,
  ETF_FUND,
  FUTURE_SCHOLAR_529,
  VARIABLE_FUND,
} from './FundTypes.js'

export function triggerDigitalData(cusip, fund, childPageName) {
  try {
    const { fundHeader, fundGroup } = fund

    if (fundHeader) {
      const title = fundHeader.symbol
        ? fundHeader.symbol + ' | ' + fundHeader.fundName
        : fundHeader.fundName

      const site = getSite()

      let _fundGroup
      let primaryCategory

      switch (fundGroup) {
        case VARIABLE_FUND:
          _fundGroup = 'Variable Products'
          primaryCategory = 'Variable Products'
          break
        case ETF_FUND:
          _fundGroup = 'Exchange Traded Funds (ETFs)'
          primaryCategory = ETF_FUND
          break
        case CLOSED_END_FUND:
          _fundGroup = 'Closed-End Funds'
          primaryCategory = CLOSED_END_FUND
          break
        case FUTURE_SCHOLAR_529:
          _fundGroup = '529 Plan'
          primaryCategory = FUTURE_SCHOLAR_529
          break
        default:
          _fundGroup = fundGroup
          primaryCategory = fundGroup
      }

      if (childPageName) {
        const childPageNameFullTitle = title + ' | ' + childPageName
        window.digitalData.page.pageInfo.pageName = childPageNameFullTitle
        window.digitalData.page.pageInfo.breadCrumbs = [
          site,
          'Products',
          _fundGroup,
          title,
          childPageName,
          childPageNameFullTitle,
        ]
      } else {
        window.digitalData.page.pageInfo.pageName = title
        window.digitalData.page.pageInfo.breadCrumbs = [
          site,
          'Products',
          _fundGroup,
          title,
        ]
      }

      window.digitalData.product = {
        productInfo: {
          productID: cusip,
          productName: fundHeader.fundName,
          primaryCategory: primaryCategory,
          subCategory1: fundHeader.fundClass,
          assetClass: fundHeader.investCatg,
        },
      }

      window.digitalData.page.attributes = {
        ...window.digitalData.page.attributes,
        dataLayerType: 'dynamic',
      }

      // refire Evergage for Interaction Studio
      if (typeof Evergage !== 'undefined' && Evergage?.reinit) {
        Evergage.reinit()
      }

      setTimeout(() => {
        if (window.digitalData) {
          // create and dispatch the event
          const event = new CustomEvent('triggerAnalytics', {
            detail: window.digitalData,
          })

          document.body.dispatchEvent(event)
        }
      }, 5000)
    }
  } catch (error) {
    console.error('trigger fund detail analytics error', error)
  }
}

export function triggerDigitalDataSimple(title, breadcrumbName) {
  try {
    setTimeout(() => {
      if (window.digitalData) {
        window.digitalData.page.pageInfo.pageName = title
        window.digitalData.page.pageInfo.breadCrumbs = [
          'Home',
          'Register',
          breadcrumbName,
        ]

        // create and dispatch the event
        const event = new CustomEvent('triggerAnalytics', {
          detail: window.digitalData,
        })

        document.body.dispatchEvent(event)
      }
    }, 5000)
  } catch (error) {
    console.error('triggerDigitalDataSimple', 'error: ' + error)
  }
}
